// Import and initialize jQuery globally for use by Telerik Report Viewer
import $ from 'jquery';

// Ensure jQuery is available globally immediately
const jQueryVersion = $.fn.jquery;
console.log('jQuery loaded:', jQueryVersion);

if (typeof window !== 'undefined') {
  window.$ = $;
  window.jQuery = $;
  
  // Ensure jQuery is available for UMD modules
  if (!window.jQuery) {
    throw new Error('jQuery failed to initialize globally');
  }
}

// Support for module exports
if (typeof module !== 'undefined' && module.exports) {
  module.exports = $;
}


